import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatTabGroup } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { MenuService } from 'src/app/services/menu.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { PrinterService } from '../../../services/printer.service';

@Component({
  selector: 'app-printer-edit',
  templateUrl: './printer-edit.component.html',
  styleUrls: ['./printer-edit.component.css']
})
export class PrinterEditComponent implements OnInit {

  @ViewChild('tabGroup',   {static: false}) tabGroup: MatTabGroup;
  loadingAction: boolean;
  loading: boolean;
  form: FormGroup;

  constructor( private menuService: MenuService
    , private notificationToastService: NotificationToastService
    , private printerService: PrinterService
    , private router: Router
    , private formBuilder: FormBuilder
    , private route: ActivatedRoute) {
        this.form = this.formBuilder.group({
          Ip: ['', Validators.required]
          , Name: ['', Validators.required]
          , DefaultPrint: ['']
          , TicketPrint: ['']
          , OrderPrint: ['']
          , Id: ['']
          , IsSafeConnection: [false]
        });
  }

  get f() { return this.form.controls; }

  cancel(): void {
    this.router.navigate(['printer-search']);
  }

  async save() {
    try {
      if (this.form.valid) {
        this.loadingAction = true;
        await this.printerService.printerUpdate(this.form.getRawValue());
        this.router.navigate(['printer-search']);
      }
    } catch (err) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Impresora');
    } finally {
      this.loadingAction = false;
    }
  }

  ngOnInit(): void {
    this.route.params.subscribe(async (params) => {
      try {
        this.loading = true;
        const id = params['Id'];
        if (id) {
          const printer = await this.printerService.getPrinterById(id);
          this.form.patchValue({
              Ip: printer.Ip
            , Name: printer.Name
            , Id: printer.Id
            , DefaultPrint: printer.DefaultPrint
            , TicketPrint: printer.TicketPrint
            , OrderPrint: printer.OrderPrint
            , IsSafeConnection: printer.IsSafeConnection
          });
        }
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Impresora');
      } finally {
        this.loading = false;
      }
    });
  }
}
